import * as React from 'react';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { createRef } from 'office-ui-fabric-react/lib/Utilities';
import { InfoBarCalloutAction } from '../schema/InfoBarMessageViewState';

export interface InfoBarMessageWithCalloutActionProps extends InfoBarCalloutAction {
    className?: string;
}

interface InfoBarMessageWithCalloutActionState {
    isCalloutVisible: boolean;
}

export class InfoBarMessageWithCustomAction extends React.Component<
    InfoBarMessageWithCalloutActionProps,
    InfoBarMessageWithCalloutActionState
> {
    private linkRef = createRef<HTMLElement>();

    constructor(props: InfoBarMessageWithCalloutActionProps) {
        super(props);

        this.state = {
            isCalloutVisible: false,
        };
    }

    private onLinkClicked = (evt: React.MouseEvent<Element>): void => {
        evt.stopPropagation();
        this.setState({
            isCalloutVisible: !this.state.isCalloutVisible,
        });
    };

    private onCalloutDismiss = (): void => {
        this.setState({
            isCalloutVisible: false,
        });
    };

    render() {
        return (
            <>
                <a
                    href={'javascript:void(0);'}
                    className={this.props.className}
                    onClick={this.onLinkClicked}
                    ref={this.linkRef}>
                    {this.props.text}
                </a>
                <Callout
                    target={this.linkRef.value}
                    directionalHint={DirectionalHint.rightTopEdge}
                    calloutMaxWidth={this.props.maxWidth}
                    onDismiss={this.onCalloutDismiss}
                    hidden={!this.state.isCalloutVisible}>
                    {this.props.calloutContent}
                </Callout>
            </>
        );
    }
}

export default InfoBarMessageWithCustomAction;
